import BachelorIcon from 'assets/icons/bachelor_programs.svg';
import MasterIcon from 'assets/icons/master_programs.svg';
import MatchIcon from 'assets/icons/program_match_ai.svg';
import UniversitiesIcon from 'assets/icons/universities.svg';

import AppReviewIcon from 'assets/icons/app_review.svg';
import SchoolShortlistIcon from 'assets/icons/free_school_shortlist.svg';
import PSIcon from 'assets/icons/ps_ai.svg';
import EndToEndIcon from 'assets/icons/end_to_end.svg';

import ResourcesIcon from 'assets/icons/resources.svg';
import WebinarsIcon from 'assets/icons/webinars.svg';
import TestimonialsIcon from 'assets/icons/testimonials.svg';
import ScholarshipsIcon from 'assets/icons/scholarships.svg';

import ExpertsIcon from 'assets/icons/experts.svg';
import PartnersIcon from 'assets/icons/partners.svg';

const data = [
  {
    title: 'Study Abroad',
    dropdown: {
      main: [
        {
          title: 'Bachelor Programs',
          description: 'Programs for when you just get out of high school.',
          icon: BachelorIcon,
          link: '/explore/bachelors',
        },
        {
          title: 'Master Programs',
          description: 'Accelerate your career further after your bachelor degree.',
          icon: MasterIcon,
          link: '/explore/masters',
        },
        {
          title: 'AI School Match',
          badge: { text: 'Recommended', class: 'rounded-pill text-bg-primary' },
          description: 'Use our AI powered tool to find your perfect school and program match.',
          icon: MatchIcon,
          link: '/profile',
        },
        {
          title: 'Top Schools',
          description: 'A selection of our recommended schools to apply to study abroad.',
          icon: UniversitiesIcon,
          link: '/explore/top-schools',
        },
      ],
      other: [
        {
          title: 'Popular Subjects',
          options: [{ title: 'Management', link: '#' }],
        },
        {
          title: 'Popular Countries',
          options: [{ title: 'United States', link: '#' }],
        },
      ],
    },
  },
  {
    title: 'Application Services',
    dropdown: {
      main: [
        {
          title: 'University Shortlist',
          badge: { text: 'FREE', class: 'rounded-pill text-bg-warning' },
          description: 'Get a bespoke list of schools from one of our expert counsellours.',
          icon: SchoolShortlistIcon,
          link: 'https://unifyapply.com/university-shortlist',
        },
        {
          title: 'Application Review',
          badge: { text: 'FREE', class: 'rounded-pill text-bg-warning' },
          description: 'Want us to check your application documents to maximize your chances?.',
          icon: AppReviewIcon,
          link: 'https://unifyapply.com/application-review',
        },
        {
          title: 'Personal Statement Builder',
          badge: { text: 'FREE', class: 'rounded-pill text-bg-warning' },
          description: 'Use our AI powered tool to help you write your personal statement.',
          icon: PSIcon,
          link: '/personal-statement-builder',
        },
        {
          title: 'Full Application Service',
          badge: { text: 'Popular', class: 'rounded-pill text-bg-success' },
          description: 'Exploring, Matching, Applying, Visa and Scholarhips, the full package.',
          icon: EndToEndIcon,
          link: 'https://unifyapply.com/our-end-to-end-service',
        },
      ],
      other: [
        // {
        //   title: 'Other Services',
        //   options: [
        //     { title: 'English Test Preparation', link: '#' },
        //     { title: 'GMAT/GRE Test Preparation', link: '#' },
        //     { title: 'CV Writing', link: '#' },
        //     { title: 'Application Review', link: '#' },
        //     { title: 'SAT Test Preparation', link: '#' },
        //     { title: 'Scholarship Essay Writing', link: '#' },
        //     { title: 'Finding the best scholarship', link: '#' },
        //     { title: 'Student Visa application', link: '#' },
        //   ],
        // },
      ],
    },
  },
  {
    title: 'Resources',
    dropdown: {
      main: [
        {
          title: 'Blog',
          description: 'Read our helpful resources about applying to study abroad.',
          icon: ResourcesIcon,
          link: 'https://blog.unifyapply.com',
        },
        {
          title: 'Upcoming Webinars',
          description: 'Register to one of our upcoming webinars or view a recording.',
          icon: WebinarsIcon,
          link: 'https://unifyapply.com/upcoming-webinars',
        },
        {
          title: 'Testimonials',
          badge: { text: 'Recommended', class: 'rounded-pill text-bg-primary' },
          description: 'We have helped over 500 students like you, see what they say about us.',
          icon: TestimonialsIcon,
          link: 'https://unifyapply.com/landings/testimonials',
        },
        {
          title: 'Our Scholarhips',
          badge: { text: 'Popular', class: 'rounded-pill text-bg-success' },
          description: 'Learn more about the scholarships we have available.',
          icon: ScholarshipsIcon,
          link: 'https://unifyapply.com/available-scholarships',
        },
      ],
      other: [
        {
          title: 'Popular Resources',
          options: [
            {
              title: 'How to choose the right program',
              link: 'https://blog.unifyapply.com/how-to-choose-the-right-masters-program/',
            },
            {
              title: 'When is the best time to apply',
              link: 'https://blog.unifyapply.com/best-time-to-start-a-masters-degree/',
            },
            {
              title: 'English tests: TOEFL, IELTS or Other',
              link: 'https://blog.unifyapply.com/toefl-ielts-or-other-english-language-tests-which-one-should-you-choose/',
            },
            {
              title: 'GMAT or GRE?',
              link: 'https://blog.unifyapply.com/gmat-or-gre-which-one-should-you-take/',
            },
            {
              title: '#111 Tips to get to Business School',
              link: 'https://blog.unifyapply.com/111-tips-to-get-to-business-school-the-ultimate-list/',
            },
            {
              title: 'Can I wave the English requirement?',
              link: 'https://blog.unifyapply.com/english-exam-entry-requirements-when-can-it-be-waived-for-business-school/',
            },
            {
              title: 'A quick guide to Accreditations',
              link: 'https://blog.unifyapply.com/a-quick-guide-to-business-school-accreditations/',
            },
          ],
        },
      ],
    },
  },
  {
    title: 'About Us',
    dropdown: {
      main: [
        {
          title: 'Testimonials',
          badge: { text: 'Recommended', class: 'rounded-pill text-bg-primary' },
          description: 'We have helped over 500 students like you, see what they say about us.',
          icon: TestimonialsIcon,
          link: 'https://unifyapply.com/landings/testimonials',
        },
        {
          title: 'Full Application Service',
          badge: { text: 'Popular', class: 'rounded-pill text-bg-success' },
          description: 'Exploring, Matching, Applying, Visa and Scholarhips, the full package.',
          icon: EndToEndIcon,
          link: 'https://unifyapply.com/our-end-to-end-service',
        },
        {
          title: 'Our Team of Experts',
          description: 'Our team has more than +20 years of experience helping students.',
          icon: ExpertsIcon,
          link: 'https://unifyapply.com/experts-team',
        },
        {
          title: 'Our Partners',
          description: 'Our network of partners enhance the Unify experience.',
          icon: PartnersIcon,
          link: 'https://unifyapply.com/our-partners',
        },
      ],
      other: [
        {
          title: 'More',
          options: [
            // { title: 'Why using Unify', link: '#' },
            // { title: 'Want to be a partner?', link: '#' },
            { title: 'Privacy Policy', link: 'https://blog.unifyapply.com/privacy-policy/' },
          ],
        },
      ],
    },
  },
];

export default data;
